/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CourseStatus = "complete" | "failed" | "incomplete" | "%future added value";
export type DelegatesPage_delegates = {
    readonly edges: ReadonlyArray<{
        readonly uuid: string;
        readonly email: string | null;
        readonly firstName: string;
        readonly lastName: string;
        readonly lastLogin: string;
        readonly createdAt: string | null;
        readonly myCourses: ReadonlyArray<{
            readonly status: CourseStatus;
        }> | null;
        readonly myClassroomCourses: ReadonlyArray<{
            readonly status: CourseStatus;
        }> | null;
        readonly nextExpiry: string | null;
    } | null> | null;
    readonly pageInfo: {
        readonly total: number;
        readonly offset: number;
        readonly limit: number;
        readonly given: number;
    } | null;
    readonly " $refType": "DelegatesPage_delegates";
};
export type DelegatesPage_delegates$data = DelegatesPage_delegates;
export type DelegatesPage_delegates$key = {
    readonly " $data"?: DelegatesPage_delegates$data;
    readonly " $fragmentRefs": FragmentRefs<"DelegatesPage_delegates">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "DelegatesPage_delegates",
        "type": "DelegatePage",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "Delegate",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "uuid",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastLogin",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "myCourses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MyCourse",
                        "plural": true,
                        "selections": (v0 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "myClassroomCourses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MyCourse",
                        "plural": true,
                        "selections": (v0 /*: any*/)
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "nextExpiry",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "total",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "offset",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "limit",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "given",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '1941eaf40520cee8fed5b76d71f3db8b';
export default node;
